// src/components/Wishlist.jsx

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';
import EmptyState from './EmptyState';

const Wishlist = () => {
  const { items, removeFromWishlist } = useWishlist();
  const [sortOrder, setSortOrder] = useState('newest');

  const sortedItems = [...items].sort((a, b) => {
    const priceA = parseFloat(String(a.price).replace(' ر.س', ''));
    const priceB = parseFloat(String(b.price).replace(' ر.س', ''));

    if (sortOrder === 'price-asc') return priceA - priceB;
    if (sortOrder === 'price-desc') return priceB - priceA;

    return 0;
  });

  return (
    <div className="min-h-screen bg-[#F6F5F2]" dir="rtl">
      <div className="container mx-auto px-4 py-10 md:py-16 relative">
        {/* زر العودة للرئيسية */}
        <div className="mb-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full
            bg-[#F2B705] hover:bg-[#1B1B1F]
            text-[#1B1B1F] hover:text-white
            font-bold transition-colors duration-300"
          >
            <svg
              className="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            العودة إلى الرئيسية
          </Link>
        </div>

        {/* العنوان */}
        <div className="text-center mb-12">
          <h1
            className="text-4xl md:text-6xl font-extrabold text-[#1B1B1F] mb-4"
            style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
          >
            المنتجات المفضلة
          </h1>

          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            المنتجات التي قمت بحفظها في قائمتك المفضلة.
          </p>
        </div>

        {/* الترتيب */}
        {items.length > 0 && (
          <div className="flex justify-end mb-8">
            <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              className="
                px-4 py-3
                border border-gray-300
                rounded-xl
                bg-white
                text-[#1B1B1F]
                focus:outline-none
                focus:ring-2
                focus:ring-[#F2B705]
                focus:border-[#F2B705]
              "
            >
              <option value="newest">المضافة حديثًا</option>
              <option value="price-asc">الأقل سعرًا</option>
              <option value="price-desc">الأعلى سعرًا</option>
            </select>
          </div>
        )}

        {/* المنتجات */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {sortedItems.length > 0 ? (
            sortedItems.map((item) => (
              <div
                key={item.id}
                className="
                  group
                  bg-white
                  rounded-2xl
                  overflow-hidden
                  shadow-[0_2px_10px_rgba(27,27,31,0.08)]
                  hover:shadow-[0_8px_25px_rgba(27,27,31,0.12)]
                  transition-all
                  duration-300
                "
              >
                <img
                  src={item.image}
                  alt={item.name}
                  className="
                    w-full
                    h-64
                    object-cover
                    transition-transform
                    duration-300
                    group-hover:scale-105
                  "
                />

                <div className="p-5 text-right">
                  <h3 className="text-lg font-bold text-[#1B1B1F]">
                    {item.name}
                  </h3>

                  <p className="text-[#F2B705] font-bold mt-2 text-lg">
                    {item.price} ر.س
                  </p>

                  <button
                    onClick={() => removeFromWishlist(item.id)}
                    className="
                      mt-4
                      w-full
                      bg-[#F2B705]
                      hover:bg-[#1B1B1F]
                      text-[#1B1B1F]
                      hover:text-white
                      font-bold
                      py-3
                      rounded-full
                      transition-colors
                      duration-300
                    "
                  >
                    إزالة من المفضلة
                  </button>
                </div>
              </div>
            ))
          ) : (
            <EmptyState
              message="لا توجد منتجات في القائمة المفضلة حاليًا."
              linkText="اذهب للتسوق"
              linkTo="/"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-20 w-20"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1}
                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                  />
                </svg>
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Wishlist;
